var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, IconButton, Typography, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { MODOS, MENSAGENS } from '../../../../../utils';
import { ROUTES, FUNCIONALIDADES } from '../../../../../routes';
import { BoxBotoes } from '../../../../../components/form_box';
import Loading from '../../../../../components/loading';
import { useParams } from 'react-router-dom';
import { consultarEnderecoCEP, getCidadesAtivos } from '../../../../../api';
import { BotaoFechar, BotaoAuxiliar } from '../../../../../components/botoes';
import { InputDados } from '../../../../../components/input_dados';
import { ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import GridComp from '../../../../../components/grid';
import { alterarEndereco as alterarEnderecoAPI, cadastrarEndereco, excluirEndereco, getCombosEnderecos, getReeducandoEnderecos, STATUS_API } from './services';
import { useAuth } from '../../../../../contexts/auth/AuthContext';
var isRegimeFechado = function (regime) { var _a; return (_a = regime === null || regime === void 0 ? void 0 : regime.toUpperCase().includes('FECHADO')) !== null && _a !== void 0 ? _a : false; };
export var ReeducandosEnderecos = function (props) {
    var _a = useAuth(), DEV = _a.DEV, getAcoesFuncionalidade = _a.getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.REEDUCANDOS_ENDEREÇOS); }, [getAcoesFuncionalidade]);
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(true), LoadingInicio = _c[0], setLoadingInicio = _c[1];
    var _d = useParams(), id = _d.id, modo = _d.modo;
    var _e = useState([]), EnderecosReeducando = _e[0], setEnderecosReeducando = _e[1];
    var _f = useState([]), TiposLogradourosDisponiveis = _f[0], setTiposLogradourosDisponiveis = _f[1];
    var _g = useState([]), TiposImoveisDisponiveis = _g[0], setTiposImoveisDisponiveis = _g[1];
    var _h = useState([]), EstadosDisponiveis = _h[0], setEstadosDisponiveis = _h[1];
    var _j = useState([]), CidadesDisponiveis = _j[0], setCidadesDisponiveis = _j[1];
    var _k = useState([]), EditarCidadesDisponiveis = _k[0], setEditarCidadesDisponiveis = _k[1];
    var _l = useState(undefined), TipoLogradouroSelecionado = _l[0], setTipoLogradouroSelecionado = _l[1];
    var _m = useState(-1), TipoImovelSelecionado = _m[0], setTipoImovelSelecionado = _m[1];
    var _o = useState(''), EstadoSelecionado = _o[0], setEstadoSelecionado = _o[1];
    var _p = useState(''), CidadeSelecionada = _p[0], setCidadeSelecionada = _p[1];
    var _q = useState(), CEP = _q[0], setCEP = _q[1];
    var _r = useState(), Logradouro = _r[0], setLogradouro = _r[1];
    var _s = useState(), Numero = _s[0], setNumero = _s[1];
    var _t = useState(), Bairro = _t[0], setBairro = _t[1];
    var _u = useState(), Complemento = _u[0], setComplemento = _u[1];
    var _v = useState(), PontoReferencia = _v[0], setPontoReferencia = _v[1];
    var _w = useState(true), PrincipalEndereco = _w[0], setPrincipalEndereco = _w[1];
    var _x = useState('Ativo'), Situacao = _x[0], setSituacao = _x[1];
    var _y = useState(false), PopupAberto = _y[0], setPopupAberto = _y[1];
    var _z = useState(), EditarID = _z[0], setEditarID = _z[1];
    var _0 = useState(''), EditarCEP = _0[0], setEditarCEP = _0[1];
    var _1 = useState(''), EditarEstadoSelecionado = _1[0], setEditarEstadoSelecionado = _1[1];
    var _2 = useState(''), EditarCidadeSelecionada = _2[0], setEditarCidadeSelecionada = _2[1];
    var _3 = useState(undefined), EditarTipoLogradouroSelecionado = _3[0], setEditarTipoLogradouroSelecionado = _3[1];
    var _4 = useState(-1), EditarTipoImovelSelecionado = _4[0], setEditarTipoImovelSelecionado = _4[1];
    var _5 = useState(''), EditarLogradouro = _5[0], setEditarLogradouro = _5[1];
    var _6 = useState(''), EditarNumero = _6[0], setEditarNumero = _6[1];
    var _7 = useState(''), EditarBairro = _7[0], setEditarBairro = _7[1];
    var _8 = useState(''), EditarComplemento = _8[0], setEditarComplemento = _8[1];
    var _9 = useState(''), EditarPontoReferencia = _9[0], setEditarPontoReferencia = _9[1];
    var _10 = useState(true), EditarPrincipalEndereco = _10[0], setEditarPrincipalEndereco = _10[1];
    var _11 = useState('Ativo'), EditarSituacao = _11[0], setEditarSituacao = _11[1];
    var setAbaAtiva = props.setAbaAtiva;
    var RegimeFechado = !!props.regimeFechado || isRegimeFechado(props.tipoRegime);
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR || RegimeFechado;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, DadosCombos, ReeducandoDadosAux, tipos_logradouros, tipos_imoveis, estados, cidades, enderecos;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([getCombosEnderecos(), getReeducandoEnderecos(id)])];
                case 1:
                    _a = _b.sent(), DadosCombos = _a[0], ReeducandoDadosAux = _a[1];
                    if (DadosCombos.Status == STATUS_API.ERRO) {
                        alert(DadosCombos.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        tipos_logradouros = DadosCombos.tipos_logradouros, tipos_imoveis = DadosCombos.tipos_imoveis, estados = DadosCombos.estados, cidades = DadosCombos.cidades;
                        setTiposLogradourosDisponiveis(tipos_logradouros);
                        setTiposImoveisDisponiveis(tipos_imoveis);
                        setEstadosDisponiveis(estados);
                        setCidadesDisponiveis(cidades);
                    }
                    if (ReeducandoDadosAux.Status == STATUS_API.ERRO) {
                        alert(ReeducandoDadosAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        enderecos = ReeducandoDadosAux.enderecos;
                        setEnderecosReeducando(enderecos);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    alert('ID do Colaborador não informado');
                    _b.label = 3;
                case 3:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        if (!CEP || CEP.trim() == '') {
            alert("CEP ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!TipoLogradouroSelecionado || TipoLogradouroSelecionado == -1) {
            alert("Tipo de Logradouro ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!Logradouro || Logradouro.trim() == '') {
            alert("Logradouro ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!TipoImovelSelecionado || TipoImovelSelecionado == -1) {
            alert("Tipo de Im\u00F3vel ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!CidadeSelecionada || CidadeSelecionada == '-1') {
            alert("Cidade ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var validarDadosEditar = function () {
        if (!EditarCEP || EditarCEP.trim() == '') {
            alert("CEP ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarTipoLogradouroSelecionado || EditarTipoLogradouroSelecionado == -1) {
            alert("Tipo de Logradouro ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarLogradouro || EditarLogradouro.trim() == '') {
            alert("Logradouro ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarTipoImovelSelecionado || EditarTipoImovelSelecionado == -1) {
            alert("Tipo de Im\u00F3vel ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarCidadeSelecionada || EditarCidadeSelecionada == '-1') {
            alert("Cidade ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var adicionarEndereco = function () { return __awaiter(void 0, void 0, void 0, function () {
        var EstadoNaturalidadeID, NaturalidadeCidadeID, Dados, Resp, enderecos;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (RegimeFechado)
                        return [2 /*return*/];
                    if (!validarDados())
                        return [2 /*return*/];
                    setLoading(true);
                    EstadoNaturalidadeID = (_a = EstadosDisponiveis === null || EstadosDisponiveis === void 0 ? void 0 : EstadosDisponiveis.find(function (item) { return item.sigla == EstadoSelecionado; })) === null || _a === void 0 ? void 0 : _a.id;
                    NaturalidadeCidadeID = (_b = CidadesDisponiveis === null || CidadesDisponiveis === void 0 ? void 0 : CidadesDisponiveis.find(function (item) { return item.codigo_ibge == CidadeSelecionada; })) === null || _b === void 0 ? void 0 : _b.id;
                    Dados = {
                        cep: CEP === null || CEP === void 0 ? void 0 : CEP.replace(/\D/g, ''),
                        tipo_logradouro_id: TipoLogradouroSelecionado,
                        tipo_imovel_id: TipoImovelSelecionado,
                        logradouro: Logradouro,
                        numero: Numero,
                        bairro: Bairro,
                        complemento: Complemento,
                        ponto_referencia: PontoReferencia,
                        cidade_id: NaturalidadeCidadeID,
                        estado_id: EstadoNaturalidadeID,
                        principal: PrincipalEndereco,
                        situacao: Situacao,
                    };
                    return [4 /*yield*/, cadastrarEndereco(Dados, id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _d.sent();
                    //console.log('Resp', JSON.stringify(Resp));
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        enderecos = Resp.dados.enderecos;
                        setEnderecosReeducando(enderecos !== null && enderecos !== void 0 ? enderecos : []);
                        limparSelecao();
                    }
                    else {
                        console.error('Erro ao cadastrar endereço:', (_c = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _c !== void 0 ? _c : Resp);
                        alert(MENSAGENS.ERRO_OPERACAO);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarEndereco = function () { return __awaiter(void 0, void 0, void 0, function () {
        var EstadoNaturalidadeID, NaturalidadeCidadeID, Dados, Resp, EnderecosAtualizados;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (RegimeFechado)
                        return [2 /*return*/];
                    if (!validarDadosEditar())
                        return [2 /*return*/];
                    setLoading(true);
                    EstadoNaturalidadeID = (_a = EstadosDisponiveis === null || EstadosDisponiveis === void 0 ? void 0 : EstadosDisponiveis.find(function (item) { return item.sigla == EditarEstadoSelecionado; })) === null || _a === void 0 ? void 0 : _a.id;
                    NaturalidadeCidadeID = (_b = CidadesDisponiveis === null || CidadesDisponiveis === void 0 ? void 0 : CidadesDisponiveis.find(function (item) { return item.codigo_ibge == EditarCidadeSelecionada; })) === null || _b === void 0 ? void 0 : _b.id;
                    Dados = {
                        cep: EditarCEP === null || EditarCEP === void 0 ? void 0 : EditarCEP.replace(/\D/g, ''),
                        tipo_logradouro_id: EditarTipoLogradouroSelecionado,
                        tipo_imovel_id: EditarTipoImovelSelecionado,
                        logradouro: EditarLogradouro,
                        numero: EditarNumero,
                        bairro: EditarBairro,
                        complemento: EditarComplemento,
                        ponto_referencia: EditarPontoReferencia,
                        cidade_id: NaturalidadeCidadeID,
                        estado_id: EstadoNaturalidadeID,
                        principal: EditarPrincipalEndereco,
                        situacao: EditarSituacao,
                    };
                    return [4 /*yield*/, alterarEnderecoAPI(Dados, id !== null && id !== void 0 ? id : '', EditarID ? EditarID.toString() : '')];
                case 1:
                    Resp = _d.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        EnderecosAtualizados = EnderecosReeducando.map(function (Item) {
                            if (Item.id == EditarID) {
                                return __assign(__assign({}, Item), Resp.dados);
                            }
                            else {
                                if (EditarPrincipalEndereco) {
                                    return __assign(__assign({}, Item), { principal: false });
                                }
                                else {
                                    return Item;
                                }
                            }
                        });
                        setEnderecosReeducando(EnderecosAtualizados);
                        setPopupAberto(false);
                        limparPopup();
                    }
                    else {
                        console.error('Erro ao alterar endereço:', (_c = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _c !== void 0 ? _c : Resp);
                        alert(MENSAGENS.ERRO_OPERACAO);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp, EnderecosAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (RegimeFechado)
                        return [2 /*return*/];
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO)) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, excluirEndereco(id)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        EnderecosAtualizados = EnderecosReeducando.filter(function (Item) { return Item.id != +id; });
                        setEnderecosReeducando(EnderecosAtualizados);
                    }
                    else {
                        setLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var limparSelecao = function () {
        setCEP('');
        setTipoLogradouroSelecionado(undefined);
        setTipoImovelSelecionado(-1);
        setLogradouro('');
        setNumero('');
        setBairro('');
        setComplemento('');
        setPontoReferencia('');
        setEstadoSelecionado('');
        setCidadeSelecionada('');
        setPrincipalEndereco(false);
        setSituacao('Ativo');
    };
    var limparPopup = function () {
        setEditarID(undefined);
        setEditarCEP('');
        setEditarTipoLogradouroSelecionado(undefined);
        setEditarTipoImovelSelecionado(-1);
        setEditarLogradouro('');
        setEditarNumero('');
        setEditarBairro('');
        setEditarComplemento('');
        setEditarPontoReferencia('');
        setEditarEstadoSelecionado('');
        setEditarCidadeSelecionada('');
        setEditarPrincipalEndereco(false);
        setEditarSituacao('Ativo');
    };
    var COLUNAS_TERMOS = [
        {
            field: 'cep',
            headerName: 'CEP',
            width: 150,
        },
        {
            field: 'bairro',
            headerName: 'Bairro',
            width: 250,
        },
        {
            field: 'cidade_id',
            headerName: 'Cidade',
            width: 250,
            valueGetter: function (_value, row) { var _a; return (_a = row.cidade) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'estado_id',
            headerName: 'UF',
            width: 100,
            valueGetter: function (_value, row) { var _a; return (_a = row.estado) === null || _a === void 0 ? void 0 : _a.sigla; },
        },
        {
            field: 'principal',
            headerName: 'Principal',
            width: 150,
            valueGetter: function (_value, row) { return (row.principal ? 'Sim' : 'Não'); },
        },
        {
            field: 'situacao',
            headerName: 'Situação',
            width: 100,
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 80,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(Box, __assign({ bgcolor: 'primary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                var _a;
                                abrirPopup((_a = params.row) === null || _a === void 0 ? void 0 : _a.id);
                            }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['ALTERAR'] }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })), _jsx(Box, __assign({ bgcolor: 'error.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { var _a; return handleDelete((_a = params.row) === null || _a === void 0 ? void 0 : _a.id); }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['EXCLUIR'] }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))] }))); },
        },
    ];
    var abrirPopup = function (EnderecoID) { return __awaiter(void 0, void 0, void 0, function () {
        var EnderecoAux, id_1, cep, tipo_logradouro_id, tipo_imovel_id, logradouro, numero, bairro, complemento, ponto_referencia, cidade, estado_id, estado, principal, situacao;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (RegimeFechado)
                        return [2 /*return*/];
                    setLoading(true);
                    EnderecoAux = EnderecosReeducando.find(function (Item) { return Item.id == +EnderecoID; });
                    if (!EnderecoAux) return [3 /*break*/, 2];
                    id_1 = EnderecoAux.id, cep = EnderecoAux.cep, tipo_logradouro_id = EnderecoAux.tipo_logradouro_id, tipo_imovel_id = EnderecoAux.tipo_imovel_id, logradouro = EnderecoAux.logradouro, numero = EnderecoAux.numero, bairro = EnderecoAux.bairro, complemento = EnderecoAux.complemento, ponto_referencia = EnderecoAux.ponto_referencia, cidade = EnderecoAux.cidade, estado_id = EnderecoAux.estado_id, estado = EnderecoAux.estado, principal = EnderecoAux.principal, situacao = EnderecoAux.situacao;
                    setEditarID(id_1);
                    setEditarCEP(cep);
                    setEditarTipoLogradouroSelecionado(tipo_logradouro_id);
                    setEditarTipoImovelSelecionado(tipo_imovel_id);
                    setEditarLogradouro(logradouro);
                    setEditarNumero(numero);
                    setEditarBairro(bairro);
                    setEditarComplemento(complemento);
                    setEditarPontoReferencia(ponto_referencia);
                    setEditarPrincipalEndereco(principal);
                    setEditarSituacao(situacao);
                    setEditarEstadoSelecionado(estado.sigla);
                    if (!estado_id) return [3 /*break*/, 2];
                    return [4 /*yield*/, onChangeEstadoEditar(estado.sigla)];
                case 1:
                    _a.sent();
                    setEditarCidadeSelecionada(cidade.codigo_ibge);
                    _a.label = 2;
                case 2:
                    setLoading(false);
                    setPopupAberto(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            setPopupAberto(false);
        }
    };
    var buscarCEP = function (CEPParm) { return __awaiter(void 0, void 0, void 0, function () {
        var CEP, Endereco;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    CEP = CEPParm.replace(/\D/g, '');
                    if (CEP.length < 8)
                        return [2 /*return*/];
                    setLoading(true);
                    DEV && console.log('CEP', CEP);
                    return [4 /*yield*/, consultarEnderecoCEP(CEP)];
                case 1:
                    Endereco = _a.sent();
                    DEV && console.log('Endereco', JSON.stringify(Endereco));
                    if (!(Endereco === null || Endereco === void 0 ? void 0 : Endereco.cep)) return [3 /*break*/, 3];
                    setLogradouro(Endereco.logradouro);
                    setBairro(Endereco.bairro);
                    setComplemento(Endereco.complemento);
                    return [4 /*yield*/, onChangeEstado(Endereco.uf)];
                case 2:
                    _a.sent();
                    setCidadeSelecionada(Endereco.ibge);
                    return [3 /*break*/, 4];
                case 3:
                    alert('CEP não encontrado');
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var buscarCEPEditar = function (CEPParm) { return __awaiter(void 0, void 0, void 0, function () {
        var CEP, Endereco;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    CEP = CEPParm.replace(/\D/g, '');
                    if (CEP.length < 8)
                        return [2 /*return*/];
                    setLoading(true);
                    DEV && console.log('CEP', CEP);
                    return [4 /*yield*/, consultarEnderecoCEP(CEP)];
                case 1:
                    Endereco = _a.sent();
                    DEV && console.log('Endereco', JSON.stringify(Endereco));
                    if (!(Endereco === null || Endereco === void 0 ? void 0 : Endereco.cep)) return [3 /*break*/, 3];
                    setEditarLogradouro(Endereco.logradouro);
                    setEditarBairro(Endereco.bairro);
                    setEditarComplemento(Endereco.complemento);
                    return [4 /*yield*/, onChangeEstadoEditar(Endereco.uf)];
                case 2:
                    _a.sent();
                    setEditarCidadeSelecionada(Endereco.ibge);
                    return [3 /*break*/, 4];
                case 3:
                    alert('CEP não encontrado');
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onChangeEstado = function (Estado) { return __awaiter(void 0, void 0, void 0, function () {
        var CidadesAux;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setEstadoSelecionado(Estado);
                    return [4 /*yield*/, getCidadesAtivos(Estado)];
                case 1:
                    CidadesAux = _a.sent();
                    setCidadesDisponiveis(CidadesAux);
                    return [2 /*return*/];
            }
        });
    }); };
    var onChangeEstadoEditar = function (Estado) { return __awaiter(void 0, void 0, void 0, function () {
        var CidadesAux;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setEditarEstadoSelecionado(Estado);
                    return [4 /*yield*/, getCidadesAtivos(Estado)];
                case 1:
                    CidadesAux = _a.sent();
                    setEditarCidadesDisponiveis(CidadesAux);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: !LoadingInicio && (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ mt: 5 }, { children: RegimeFechado ? (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Endere\u00E7o" })), _jsx(Typography, { children: "Os dados de endere\u00E7o ficam indispon\u00EDveis para colaboradores em regime fechado." }), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(0); } }, { children: "Voltar" })), _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.REEDUCANDOS })] }))] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Endere\u00E7o" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'cep', label: 'CEP', value: CEP, onChange: function (event) { return setCEP(event.target.value); }, onBlur: function (event) { return buscarCEP(event.target.value); }, mask: '99.999-999', disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'tipo-logradouro', label: 'Tipo de Logradouro', placeholder: 'Tipo de Logradouro', value: TipoLogradouroSelecionado, onChange: function (event) {
                                                setTipoLogradouroSelecionado(event.target.value);
                                            }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), TiposLogradourosDisponiveis === null || TiposLogradourosDisponiveis === void 0 ? void 0 : TiposLogradourosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'tipo-imovel', label: 'Tipo de Im\u00F3vel', placeholder: 'Tipo de Im\u00F3vel', value: TipoImovelSelecionado, onChange: function (event) {
                                                setTipoImovelSelecionado(event.target.value);
                                            }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), TiposImoveisDisponiveis === null || TiposImoveisDisponiveis === void 0 ? void 0 : TiposImoveisDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, { item: true, xs: 5, sm: 5 }), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'logradouro', label: 'Logradouro', value: Logradouro, onChange: function (event) { return setLogradouro(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'numero', label: 'N\u00FAmero', value: Numero, onChange: function (event) { return setNumero(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'bairro', label: 'Bairro', value: Bairro, onChange: function (event) { return setBairro(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'complemento', label: 'Complemento', value: Complemento, onChange: function (event) { return setComplemento(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'ponto-referencia', label: 'Ponto de Refer\u00EAncia', value: PontoReferencia, onChange: function (event) { return setPontoReferencia(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'estado', label: 'Estado', s: true, placeholder: 'Estado', value: EstadoSelecionado, onChange: function (event) {
                                                onChangeEstado(event.target.value);
                                            }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), EstadosDisponiveis === null || EstadosDisponiveis === void 0 ? void 0 : EstadosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.sigla }, { children: item.nome }), item.sigla)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'cidade', label: 'Cidade', placeholder: 'Cidade', value: CidadeSelecionada, onChange: function (event) {
                                                setCidadeSelecionada(event.target.value);
                                            }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), CidadesDisponiveis === null || CidadesDisponiveis === void 0 ? void 0 : CidadesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.codigo_ibge }, { children: item.nome }), item.codigo_ibge)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'principal', label: 'Principal', placeholder: 'Principal', value: PrincipalEndereco, onChange: function (event) {
                                                var Valor = event.target.value;
                                                setPrincipalEndereco(Valor == undefined ? undefined : Valor == 'true');
                                            }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), _jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'situacao', label: 'Situa\u00E7\u00E3o', placeholder: 'Situa\u00E7\u00E3o', value: Situacao, onChange: function (event) {
                                                setSituacao(event.target.value);
                                            }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: limparSelecao, backgroundColor: 'error.main', disabled: DESABILITAR_CAMPOS }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ sx: { ml: 1 }, onClick: adicionarEndereco, backgroundColor: 'principal.main', disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['CADASTRAR'] }, { children: "Adicionar" }))] }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: EnderecosReeducando, columns: COLUNAS_TERMOS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { } }) })), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(0); } }, { children: "Voltar" })), _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.REEDUCANDOS })] }))] })) })), _jsxs(Dialog, __assign({ open: PopupAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Editar Termo ou Contrato" }), _jsxs(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: [_jsx(Box, __assign({ mb: 2, mt: 2 }, { children: _jsx(InputDados, { id: 'id', label: 'ID', value: EditarID, disabled: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-cep', label: 'CEP', value: EditarCEP, onChange: function (event) { return setEditarCEP(event.target.value); }, onBlur: function (event) { return buscarCEPEditar(event.target.value); }, mask: '99.999-999', disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-logradouro', label: 'Tipo de Logradouro', placeholder: 'Tipo de Logradouro', value: EditarTipoLogradouroSelecionado, onChange: function (event) {
                                            setEditarTipoLogradouroSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), TiposLogradourosDisponiveis === null || TiposLogradourosDisponiveis === void 0 ? void 0 : TiposLogradourosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-imovel', label: 'Tipo de Im\u00F3vel', placeholder: 'Tipo de Im\u00F3vel', value: EditarTipoImovelSelecionado, onChange: function (event) {
                                            setEditarTipoImovelSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), TiposImoveisDisponiveis === null || TiposImoveisDisponiveis === void 0 ? void 0 : TiposImoveisDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-logradouro', label: 'Logradouro', value: EditarLogradouro, onChange: function (event) { return setEditarLogradouro(event.target.value); }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-numero', label: 'N\u00FAmero', value: EditarNumero, onChange: function (event) { return setEditarNumero(event.target.value); }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-bairro', label: 'Bairro', value: EditarBairro, onChange: function (event) { return setEditarBairro(event.target.value); }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-complemento', label: 'Complemento', value: EditarComplemento, onChange: function (event) { return setEditarComplemento(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-ponto-referencia', label: 'Ponto de Refer\u00EAncia', value: EditarPontoReferencia, onChange: function (event) { return setEditarPontoReferencia(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-estado', label: 'Estado', placeholder: 'Estado', value: EditarEstadoSelecionado, onChange: function (event) {
                                            onChangeEstadoEditar(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), EstadosDisponiveis === null || EstadosDisponiveis === void 0 ? void 0 : EstadosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.sigla }, { children: item.nome }), item.sigla)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-cidade', label: 'Cidade', placeholder: 'Cidade', value: EditarCidadeSelecionada, onChange: function (event) {
                                            setEditarCidadeSelecionada(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), EditarCidadesDisponiveis === null || EditarCidadesDisponiveis === void 0 ? void 0 : EditarCidadesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.codigo_ibge }, { children: item.nome }), item.codigo_ibge)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-principal', label: 'Principal', placeholder: 'Principal', value: EditarPrincipalEndereco, onChange: function (event) {
                                            var Valor = event.target.value;
                                            setEditarPrincipalEndereco(Valor == undefined ? undefined : Valor == 'true');
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), _jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-situacao', label: 'Situa\u00E7\u00E3o', placeholder: 'Situa\u00E7\u00E3o', value: EditarSituacao, onChange: function (event) {
                                            setEditarSituacao(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })) }))] })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: alterarEndereco, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), loading && _jsx(Loading, {})] })) }));
};
export default ReeducandosEnderecos;
